import React from 'react';
import styled from 'styled-components';
import { ModalFactory, Text } from 'components';
import { theme, toRem } from 'design';

const ModalSectionTitle = styled(Text)`
  margin-bottom: ${toRem(theme.space.lg)};
  align-self: start;
`;

export const TipSharingInfoModal = ({ hideModal }: { hideModal: () => void }) => (
  <ModalFactory onClose={hideModal} isActive>
    <ModalSectionTitle className="points" fontWeight="semibold">
      Tip Sharing
    </ModalSectionTitle>
    <Text size="small">
      Tip sharing distributes tips from one contributor to other job roles according to a specified percentage. There are two ways to set up tip sharing rules:
      <br /> <br />
      <b>Job Rules</b> distribute tips based on the job role an employee was working when a check was processed. For example, if servers collect $1,000 in tips and share 3% with bussers, a $30 pool is created and split among bussers based
      on hours worked.
      <br /> <br />
      <b>Owner Rules</b> distribute tips based on the specific employee or system that owns a check, regardless of the job they worked or whether they have a clock-in entry. This is useful for online ordering systems, shared bar terminals,
      or individual employees who need a custom rule.
      <br /> <br />
      If an owner rule exists for a contributor, it takes priority over any job rule for that same employee.
    </Text>
  </ModalFactory>
);
